import { useCallback } from 'react';
import { APPLY_COUPON, REMOVE_COUPON } from '../queries/cart';
import useCartMutation from './useCartMutation';

const useApplyCoupon = () => {
  const [mutation, { loading, error }] = useCartMutation(APPLY_COUPON);
  const [removeMutation, { loading: removeLoading, error: removeError }] = useCartMutation(REMOVE_COUPON);

  const applyCoupon = useCallback(
    (couponCode, cartId) => {
      return mutation({
        variables: {
          input: {
            coupon_code: couponCode,
            cart_id: cartId,
          },
        },
      });
    },
    [mutation],
  );

  const removeCoupon = useCallback(
    cartId => {
      return removeMutation({
        variables: {
          input: {
            cart_id: cartId,
          },
        },
      });
    },
    [removeMutation],
  );

  return {
    applyCoupon,
    loading,
    error,
    removeCoupon,
    removeLoading,
    removeError,
  };
};

export default useApplyCoupon;
